const REASONS = [
  {
    icon: 'ri-water-flash-line',
    title: 'World-Class Waterfalls',
    desc: 'Glen Falls, Dry Falls, Bridal Veil Falls, and more — all within a short drive of most Highlands cabins.',
  },
  {
    icon: 'ri-landscape-line',
    title: 'Elevation & Cool Climate',
    desc: 'At 4,118 feet, Highlands stays 10–15°F cooler than surrounding lowlands — a natural escape from summer heat.',
  },
  {
    icon: 'ri-restaurant-2-line',
    title: 'Acclaimed Dining',
    desc: 'Downtown Highlands has one of the highest concentrations of acclaimed restaurants per capita in the Southeast.',
  },
  {
    icon: 'ri-walk-line',
    title: 'Hiking & Trails',
    desc: 'Whiteside Mountain, Panthertown Valley, and dozens of waterfall trails are all accessible from a Highlands cabin base.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Boutique Shopping',
    desc: 'Unique galleries, antique shops, and local boutiques line Main Street — all walkable from the center of town.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Four-Season Beauty',
    desc: 'Spring wildflowers, summer cool, fall foliage, and winter snow make Highlands a year-round destination.',
  },
];

export default function WhyHighlandsSection() {
  return (
    <section className="bg-[#EDE8E0] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-16">
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Why Highlands</p>
            <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-6">
              Why Stay in a Cabin<br /><em className="italic">in Highlands, NC?</em>
            </h2>
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-4">
              Highlands, North Carolina is one of the most sought-after mountain destinations in the Southeast — and for good reason. Perched at over 4,000 feet in the Blue Ridge Mountains, it offers a rare combination of natural beauty, cultural richness, and genuine mountain character.
            </p>
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
              Staying in a cabin here means waking up to forest views, spending your days exploring waterfalls and trails, and ending your evenings by a fireplace with the sounds of the mountains around you. It&apos;s a different kind of vacation — slower, more intentional, and deeply restorative.
            </p>
          </div>
          <div className="rounded-2xl overflow-hidden h-[420px]">
            <img
              src="https://public.readdy.ai/ai/img_res/d395aaf6ae1a7a793c5631ab3d1d03da.jpg"
              alt="Blue Ridge Mountain views from a cabin in Highlands NC"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {REASONS.map((reason) => (
            <div key={reason.title} className="bg-[#FAFAF8] rounded-2xl p-7 flex gap-5 items-start">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
                <i className={`${reason.icon} text-[#2D4A3E] text-lg`} />
              </div>
              <div>
                <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-2">{reason.title}</h3>
                <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{reason.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
